export const DOMAIN_CREATE = {
    TITLE: 'Track more domains',
    SUBTITLE: 'Add a domain',
    INPUT_LABEL: 'DOMAIN:',
    NOTE_1: 'Note: Domains containing unicode characters should be entered using their',
    NOTE_2: ', トラックssl.com should be entered as xn--ssl-zj4byd3a5u.com.',
    NOTE_LINK: 'punycode representation',
    SUBMIT: 'Create domain',
    BACK: 'Back',
}